module.exports = __webpack_public_path__ + "images/store_icon_b04f1e51.png";


//////////////////
// WEBPACK FOOTER
// ./images/store_icon.png
// module id = 13
// module chunks = 0